
import { Component } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";


@Component({
    components: {
    }
})
export default class Home extends Vue {
  created() {
      console.log("Home page has been created.")
    
        require(`../../assets/images/ideas/booshee1.jpeg`)
        let path = "img/booshe1.jpeg"
        //console.log("imagePath: " + path)
        return path

  }


  onPuzzleClick() {
      this.$router.push( "/demo");
  }
}
